/* eslint-disable @typescript-eslint/no-explicit-any */
import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFetchBaseQuery } from "@/redux/apiFetchBaseQuery";

// Define a type for Google Places prediction (optional but recommended)
interface GooglePlacePrediction {
	text: string;
	placeId: string;
}
interface GooglePlaceDetail {
	address: string;
	city: string;
	state: string;
	postalCode: string;
}

interface GeoFenceLocation {
	businessName?: string;
	address: string;
	address2?: string;
	city: string;
	state: string;
	postalCode: string;
	sourceRow?: number;
}

export const googlePlacesAutoCompleteSlice = createApi({
	reducerPath: "googlePlacesAutoCompleteSlice",
	baseQuery: apiFetchBaseQuery,
	tagTypes: ["googlePlaces"],
	endpoints: builder => ({
		getGooglePlacesAutocomplete: builder.query<GooglePlacePrediction[], string>({
			query: (input: string) => ({
				url: `/agency-order/google-places/search?input=${encodeURIComponent(input)}`,
			}),
			transformResponse: (response: any) => response.data.predictions,
			providesTags: ["googlePlaces"],
		}),
		getGooglePlaceDetails: builder.query<GooglePlaceDetail, string>({
			query: (placeId: string) => ({
				url: `/agency-order/google-places/details?placeId=${encodeURIComponent(placeId)}`,
			}),
			transformResponse: (response: any) => response.data.placedetail,
			providesTags: ["googlePlaces"],
		}),
		validateGeoFenceLocations: builder.mutation<any, GeoFenceLocation[]>({
			query: locations => ({
				url: `/agency-order/google-places/validate`,
				method: "POST",
				body: { locations },
			}),
		}),
	}),
});

export const {
	useGetGooglePlacesAutocompleteQuery,
	useGetGooglePlaceDetailsQuery,
	useValidateGeoFenceLocationsMutation,
} = googlePlacesAutoCompleteSlice;
